const rankings = [
  { rank: 1, title: '暑期档票房冠军《星际迷航》全网热播', tag: '动作科幻', views: '98.6万', hot: true },
  { rank: 2, title: '口碑神作《长安三万里》深度解析再掀热议', tag: '动画历史', views: '87.3万', hot: true },
  { rank: 3, title: '悬疑新剧《暗夜追踪》第三季重磅回归', tag: '悬疑犯罪', views: '76.1万', hot: true },
  { rank: 4, title: '经典港片修复版《无间道》系列全集上线', tag: '经典警匪', views: '65.8万', hot: false },
  { rank: 5, title: 'Netflix热剧《鱿鱼游戏2》中文配音版', tag: '惊悚剧情', views: '59.2万', hot: false },
  { rank: 6, title: '国产动画《深海》加长版独家放送', tag: '国漫奇幻', views: '52.4万', hot: false },
  { rank: 7, title: '日漫新番《咒术回战》最终季连载更新中', tag: '热血动漫', views: '48.9万', hot: false },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-3">热门排行</h2>
          <p className="text-sm text-foreground-500">实时热播榜单，发现全网最受欢迎影视内容</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-3 md:gap-4">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 hover:bg-background-200/50 border border-background-200/40 transition-all cursor-pointer"
            >
              <div className={`w-9 h-9 flex-shrink-0 flex items-center justify-center rounded-lg font-heading text-sm font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-400'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="text-xs px-2 py-0.5 rounded bg-accent-100/30 text-accent-400 font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                  {item.hot && (
                    <i className="ri-fire-fill text-accent-400 text-xs"></i>
                  )}
                </div>
                <p className="text-sm text-foreground-200 group-hover:text-primary-400 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </p>
                <p className="text-xs text-foreground-600 mt-1">{item.views} 次播放</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}